import { resolveMediaList, resolveMediaUrl } from './mediaHelpers';

const SERVICE_COUNTER_ICONS = {
  counter1: 'counter/icons/ser-single/si1.png',
  counter2: 'counter/icons/ser-single/si2.png',
};

export const serviceImage = (path) => {
  if (!path) return null;
  if (typeof path === 'string' && (path.startsWith('http') || path.startsWith('/'))) {
    return path;
  }
  return `${process.env.PUBLIC_URL}/assets/images/${path}`;
};

const lineList = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === 'string') {
    return value
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);
  }
  return [];
};

export const mapServiceListItem = (service) => ({
  id: service.documentId,
  slug: service.slug,
  title: service.title,
  description: service.description,
  link: `/services/${service.slug}`,
  listIcon:
    resolveMediaUrl(service.listIcon) || serviceImage(service.listIconPath),
});

export const mapServiceHomeItem = (service) => ({
  id: service.documentId,
  slug: service.slug,
  title: service.title,
  description: service.description,
  link: `/services/${service.slug}`,
  image:
    resolveMediaUrl(service.coverImage) || serviceImage(service.imagePath),
  icon: resolveMediaUrl(service.homeIcon) || serviceImage(service.iconPath),
  listIcon:
    resolveMediaUrl(service.listIcon) || serviceImage(service.listIconPath),
});

const mapServiceClientReview = (item, index) => ({
  id: item.id ?? index,
  quote: item.quote,
  name: item.clientName,
  role: item.clientTitle || '',
  image:
    resolveMediaUrl(item.photo) ||
    (item.photoPath ? serviceImage(item.photoPath) : null),
});

export const mapServiceDetail = (service) => {
  const uploadedGallery = resolveMediaList(service.galleryImages);
  const legacyGallery = lineList(service.galleryPaths);

  return {
    slug: service.slug,
    title: service.title,
    subtitle: service.subtitle || '',
    heading: service.heading || service.title,
    intro: service.intro || '',
    bullets: lineList(service.bullets),
    closing: service.closing || '',
    image:
      resolveMediaUrl(service.coverImage) || serviceImage(service.imagePath),
    gallery: uploadedGallery.length
      ? uploadedGallery
      : legacyGallery.map((path) => serviceImage(path)).filter(Boolean),
    counter1: {
      value: service.counter1Value || 0,
      label: service.counter1Label || '',
      icon: serviceImage(SERVICE_COUNTER_ICONS.counter1),
    },
    counter2: {
      value: service.counter2Value || 0,
      label: service.counter2Label || '',
      icon: serviceImage(SERVICE_COUNTER_ICONS.counter2),
    },
    clientReviews: (service.clientReviews || [])
      .map(mapServiceClientReview)
      .filter((item) => item.quote && item.name),
  };
};
